import React, { useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Stack,
  styled,
  Typography,
} from "@mui/material";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import Axios from "axios";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import generatePayPremuimReqBody from "../../Utilities/LifeInsuranceRequestBodies/PayPremuimReqBodies/payPremuimReqBody";
import PaymentRedirectForm from "../../AgentAuthentication/HdfcErgoKYC/Utilities/PaymentRedirectForm";
import axiosInstance from "../../Utilities/djangoAxiosInstance";

const DownLoadButton = styled(Button)(({ theme }) => ({
  color: theme.palette.getContrastText("#0d409b"),
  backgroundColor: "#0d409b",
  border: "1px solid",
  borderRadius: "24px",
  "&:hover": {
    backgroundColor: "#0d409b",
  },
}));

const PaymentPage = () => {
  const { id } = useParams();
  const [responseData, setResponseData] = useState({});
  const [title, setTitle] = useState("");
  const [clickedPayHere, setClickedPayHere] = useState(false);
  const [transferData, setTransferData] = useState({});
  const [savedValidate, setSavedValidate] = useState({});
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const [searchParam] = useSearchParams();

  const productIdArray = id.split("*");
  //const productRef = productIdArray[0]
  const transId = productIdArray[0];
  const validateFormid = productIdArray[1];

  /*  const splitSearch  = location.search.split("&&")
  const aid =splitSearch[0].split('=')[1]
  const prod_id =splitSearch[1].split('=')[1] */

  const payHere = () => {
    console.log("link", responseData);

    if (responseData.companyName === "Star Health ") {
      window.open(`${responseData.paymentUrl}`);
    } else if (responseData.companyName === "Shriram Life") {
      setClickedPayHere(true);
      let domainFrontEnd = "";
      let domainDjango = "";

      if (window.location.hostname === "localhost") {
        domainFrontEnd = process.env.REACT_APP_LOCAL_FRONT_END;
        domainDjango = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domainFrontEnd = process.env.REACT_APP_PRODUCTION_FRONT_END;
        domainDjango = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domainFrontEnd = process.env.REACT_APP_UAT_FRONT_END;
        domainDjango = process.env.REACT_APP_UAT_DJANGO;
      }

      //let ReturnURL = `${domainFrontEnd}/lifeInsurance/paymentStatus/${transId}*${validateFormid}`;
      let ReturnURL = `${domainFrontEnd}/thankyou/${transId}`;

      let paymentReq = generatePayPremuimReqBody(savedValidate, ReturnURL);
      console.log("req", paymentReq);
      axiosInstance
        .post(
          `api/life-insurance/pay-premium/${transferData.A_id}/`,
          JSON.stringify(paymentReq)
        )
        .then((response) => {
          console.log(response, "response in pay premium");
          if (response.data.ResultSet.ResponseCode === "200") {
            setClickedPayHere(false);

            window.open(
              `http://${response.data.ResultSet.Response.PaymentUrl}`
            );
          } else {
            setClickedPayHere(false);
            alert(response.data.ResultSet.ResponseMsg);
          }
        })
        .catch((e) => {
          console.log("err", e.response);
        });
    } else if (responseData.companyName === "HDFC Ergo") {
      console.log("hdfc payment here");
      let domain = "";
      if (window.location.hostname === "localhost") {
        domain = process.env.REACT_APP_LOCAL_DJANGO;
      } else if (window.location.hostname.trim() === "acuvisor.com") {
        domain = process.env.REACT_APP_PRODUCTION_DJANGO;
      } else {
        domain = process.env.REACT_APP_UAT_DJANGO;
      }
      let paymenturi = responseData.paymentUrl;
      console.log(paymenturi);
      axiosInstance
        .post(paymenturi, { pay_person: "customer" })
        .then((response) => {
          if (response.status === 200) {
            console.log("Get Checksum", response.data);
            const Checksum = response.data;

            PaymentRedirectForm(Checksum);
          }
        })
        .catch((e) => {
          alert(e);
        });
    } else {
      window.open(`${responseData.paymentUrl}`);
    }
  };

  const getTransferData = () => {
    let domain = "";

    axiosInstance
      .get(`api/shriram/plp-validate-response/${transId}/`)
      .then((response) => {
        //checkPaymentStatus(response.data.A_id);
        if (response.status === 200) {
          setTransferData(response.data);

          axiosInstance
            .get(
              `api/payment-details/${response.data.A_id}/${response.data.Acuvisor_product_id}`
              //`${domain}/api/health/createquote-response/${referencetId}/`
            )
            .then((res) => {
              console.log("respon", res);
              if (res.data.InsuranceCategoryType === "Term Insurance") {
                setTitle("Life Insurance");
              } else {
                setTitle("Health Insurance");
              }
              setResponseData(res.data);
            });
        }
        console.log("trans of pay premium", response);
      });
  };

  const getHealthTransferData = () => {
    let domain = "";

    setLoading(true);

    axiosInstance
      .get(`api/health/transfer-data/${transId}/`)
      .then((response) => {
        //checkPaymentStatus(response.data.A_id);
        if (response.status === 200) {
          setTransferData(response.data);

          axiosInstance
            .get(
              `api/payment-details/${response.data.A_id}/${response.data.Acuvisor_product_id}`
              //`${domain}/api/health/createquote-response/${referencetId}/`
            )
            .then((res) => {
              console.log("respon", res);
              if (res.data.InsuranceCategoryType === "Term Insurance") {
                setTitle("Life Insurance");
              } else {
                setTitle("Health Insurance");
              }
              setResponseData(res.data);
              setLoading(false);
            });
        }
        console.log("trans of pay premium", response);
      });
  };

  const getValidateFormDetails = () => {
    let domain = "";

    axiosInstance
      .get(`api/life-insurance/get-validate-proposal/${validateFormid}/`)
      .then((response) => {
        // setTransferData(response.data)
        console.log(response, "Savedvalidate resp");
        setSavedValidate(response.data);
        //setPlanData(response.data.Request.Proposal.Plan)
      });
  };

  useEffect(() => {
    console.log("loc", location.search);
    console.log(
      "searchparam",
      searchParam?.get("aid"),
      searchParam?.get("prod_id")
    );
    if (location.search !== "") {
      console.log("healthhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh");
      getHealthTransferData();
    } else {
      getValidateFormDetails();
      getTransferData();
    }
  }, []);
  return (
    <div>
      {/*      <div className="header-sec">
        <p className="insurence-title">
          Health Insurance <KeyboardArrowDownIcon />
        </p>
      </div> */}
      {loading ? (
        <div>
          <Box
            className="mx-auto"
            style={{
              display: "flex",
              marginTop: "10px",
              justifyContent: "center",
            }}
          >
            <CircularProgress
              size={48}
              sx={{
                color: "red",
              }}
            />
          </Box>
        </div>
      ) : (
        <div>
          <div className=" ">
            {Object.keys(responseData).length > 0 && (
              <CategoryHeader title={title} />
            )}
          </div>
          <Box sx={{ padding: "16px", marginTop: "16px" }}>
            {Object.keys(responseData).length > 0 && (
              <Card>
                <Box sx={{ display: "flex" }}>
                  <img
                    className="bg-white img-thumbnail rounded"
                    width={100}
                    height={100}
                    src={responseData.companyLogo}
                  />
                  <Box>
                    <Typography>{responseData.companyName}</Typography>
                    {/*  <Typography>{responseData.vendor}</Typography> */}
                  </Box>
                </Box>

                <CardContent>
                  <Typography
                    variant="h5"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      fontWeight: 600,
                    }}
                  >
                    Premiuim Details
                  </Typography>

                  <div className="mt-3 mb-3">
                    <span style={{ float: "left" }}>Package Premiuim </span>
                    <span style={{ float: "left", color: "silver" }}>
                      ..................
                    </span>
                    <span style={{ float: "right" }}>
                      <b>{responseData.premium}</b>
                    </span>
                    <br />
                    <span style={{ float: "left" }}>GST@18%</span>
                    <span style={{ float: "left", color: "silver" }}>
                      ..................
                    </span>
                    <span style={{ float: "right" }}>
                      <b>{responseData.serviceTax}</b>
                    </span>
                    <br />
                    <span style={{ float: "left" }}>Final Premium</span>
                    <span style={{ float: "left", color: "silver" }}>
                      ..................
                    </span>
                    <span style={{ float: "right" }}>
                      <b>{responseData.TotalPremium}</b>
                    </span>
                  </div>
                </CardContent>
              </Card>
            )}
          </Box>
          <Stack spacing={2} sx={{ padding: "16px", marginTop: "16px" }}>
            {clickedPayHere ? (
              <Box
                className="mx-auto"
                style={{
                  display: "flex",
                  marginTop: "10px",
                  justifyContent: "center",
                }}
              >
                <CircularProgress
                  size={48}
                  sx={{
                    color: "red",
                  }}
                />
              </Box>
            ) : (
              <DownLoadButton onClick={payHere}>Pay Here</DownLoadButton>
            )}
          </Stack>
        </div>
      )}
    </div>
  );
};

export default PaymentPage;
